const componentModules = {
  'overflow-list': '@theme/overflow-list',
  'quick-add-component, quick-add-dialog': '@theme/quick-add',
  'cart-discount-component': '@theme/cart-discount',
  'dialog-component': '@theme/dialog',
  'variant-picker': '@theme/variant-picker',
  'product-card, product-card-link, swatches-variant-picker-component': '@theme/product-card',
  'product-form-component, add-to-cart-component': '@theme/product-form',
  'fly-to-cart': '@theme/fly-to-cart',
  'accordion-custom': '@theme/accordion-custom',
  'deferred-media, product-model': '@theme/media',
  'product-price': '@theme/product-price',
  'product-sku-component': '@theme/product-sku',
  'product-title': '@theme/product-title',
  'product-inventory': '@theme/product-inventory',
  'show-more-component': '@theme/show-more',
  'slideshow-component': '@theme/slideshow',
  'layered-slideshow-component': '@theme/layered-slideshow',
  'anchored-popover-component': '@theme/anchored-popover',
  'floating-panel-component': '@theme/floating-panel',
  'video-background-component': '@theme/video-background',
  'quantity-selector-component': '@theme/component-quantity-selector',
  'media-gallery': '@theme/media-gallery',
  'rte-formatter': '@theme/rte-formatter',
  'volume-pricing': '@theme/volume-pricing',
  'price-per-item': '@theme/price-per-item',
  'volume-pricing-info': '@theme/volume-pricing-info',
  'localization-form-component, dropdown-localization-component, drawer-localization-component': '@theme/localization',
};

const pendingModules = new Map(Object.entries(componentModules));

function loadComponents(root = document) {
  for (const [selector, moduleName] of pendingModules) {
    const matches = root instanceof Element && root.matches(selector);
    if (!matches && !root.querySelector(selector)) continue;

    pendingModules.delete(selector);
    import(moduleName).catch((error) => {
      pendingModules.set(selector, moduleName);
      console.error(`Unable to load ${moduleName}`, error);
    });
  }
}

loadComponents();

if (pendingModules.size > 0) {
  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node instanceof Element) loadComponents(node);
      }
    }

    if (pendingModules.size === 0) observer.disconnect();
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
}
